import { forwardRef, useEffect, useState } from 'react'

import {
    Radio,
    RadioGroup,
    Grid,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputLabel,
    Input,
    TextField,
    Slide
} from '@mui/material';
import useHistorialClinico from '../../../hooks/useHistorialClinico';


const HeredoFamiliaresDF = () => {

    const { datos, handleChangeClinico, historialFecha} = useHistorialClinico()
    const { antecedentesHeredoFamiliares } = datos
    const [diab, setDiab] = useState(historialFecha.antecedentesHeredoFamiliares.antherDiabetes?true:false);
    const [hip, setHip] = useState(historialFecha.antecedentesHeredoFamiliares.antherHipertencion?true:false);
    const [can, setCan] = useState(historialFecha.antecedentesHeredoFamiliares.antherCancer?true:false);
    const [cor, setCor] = useState(historialFecha.antecedentesHeredoFamiliares.antherEnfermedadCorazon?true:false);
    const [rin, setRin] = useState(historialFecha.antecedentesHeredoFamiliares.antherEnfermedadRinon?true:false);
    const [asm, setAsm] = useState(historialFecha.antecedentesHeredoFamiliares.antherAsmaP?true:false);
    const [neu, setNeu] = useState(historialFecha.antecedentesHeredoFamiliares.antherNeurodegenerativas?true:false);
    const [auto, setAuto] = useState(historialFecha.antecedentesHeredoFamiliares.antherAutoinmunes?true:false);
    const [disc, setDisc] = useState(historialFecha.antecedentesHeredoFamiliares.antherDiscAuditvaVisual?true:false);
    const [conv, setConv] = useState(historialFecha.antecedentesHeredoFamiliares.antherConvulsiones?true:false);

    const validarDataHF = ()=>{

    }   

    // useEffect(()=>{
    //     console.log(datos)
    // }, [antecedentesHeredoFamiliares])
    
    return (

        <Grid container spacing={2} p={1} style={{ backgroundColor:"#FFF" }}>
            {/*------------ Diabetes--------------- */}

            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="antherDiabetes" style={{ marginRight: "10px", width: "30%" }}>Diabetes (azúcar elevada)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="antherDiabetes"
                            name="antecedentesHeredoFamiliares,antherDiabetes"
                            disabled
                            onChange={(e) => { setDiab(!diab); handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherDiabetes}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>

            <Grid item lg={7} sm={7} xs={12}>
                {diab ?
                    <Slide direction="left" in={diab} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherDiabetesQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherDiabetesQuien"
                            disabled
                            onChange={(e) => { handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherDiabetesQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Hipertensión (presión alta)--------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Hipertensión (presión alta)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherHipertencion"
                            disabled
                            onChange={(e) => { setHip(!hip); handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherHipertencion}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {hip ?
                    <Slide direction="left" in={hip} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherHipertencionQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherHipertencionQuien"
                            value={historialFecha.antecedentesHeredoFamiliares.antherHipertencionQuien}
                            disabled
                            onChange={(e) => { handleChangeClinico(e) }}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Cancer --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Cáncer</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherCancer"
                            disabled
                            onChange={(e) => { setCan(!can); handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherCancer}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {can ?
                    <Slide direction="left" in={can} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherCancerQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherCancerQuien"
                            value={historialFecha.antecedentesHeredoFamiliares.antherCancerQuien}
                            disabled
                            onChange={(e) => { handleChangeClinico(e) }}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Corazon --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedad del corazón</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherEnfermedadCorazon"
                            disabled
                            onChange={(e) => { setCor(!cor); handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherEnfermedadCorazon}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {cor ?
                    <Slide direction="left" in={cor} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherEnfermedadCorazonQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherEnfermedadCorazonQuien"
                            disabled
                            onChange={(e) => { handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherEnfermedadCorazonQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Riñon --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Enfermedad de riñón</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherEnfermedadRinon"
                            disabled
                            onChange={(e) => { setRin(!rin); handleChangeClinico(e)}}
                            value={historialFecha.antecedentesHeredoFamiliares.antherEnfermedadRinon}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {rin ?
                    <Slide direction="left" in={rin} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="medicoTitulo"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherEnfermedadRinonQuien"
                            disabled
                            onChange={(e) => {handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherEnfermedadRinonQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Asma --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Asma (silba el pecho)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherAsmaP"
                            disabled
                            onChange={(e) => { setAsm(!asm); handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherAsmaP}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {asm ?
                    <Slide direction="left" in={asm} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherAsmaQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherAsmaQuien"
                            disabled
                            onChange={(e) => {handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherAsmaQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Neuro --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Neurodegenerativas (Depresión, Demencia,Parkinson, Alzheimer)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherNeurodegenerativas"
                            disabled
                            onChange={(e) => { setNeu(!neu); handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherNeurodegenerativas}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {neu ?
                    <Slide direction="left" in={neu} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherNeurodegenerativasQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherNeurodegenerativasQuien"
                            disabled
                            onChange={(e) => {handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherNeurodegenerativasQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Auto --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Autoinmunes (LUPUS, Artritis, Enf Tiroidea)</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherAutoinmunes"
                            disabled
                            onChange={(e) => { setAuto(!auto) ; handleChangeClinico(e)}}
                            value={historialFecha.antecedentesHeredoFamiliares.antherAutoinmunes}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {auto ?
                    <Slide direction="left" in={auto} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherAutoinmunesQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherAutoinmunesQuien"
                            disabled
                            onChange={(e) => {handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherAutoinmunesQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Discapacidad --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Discapacidad auditiva o visual</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherDiscAuditvaVisual"
                            disabled
                            onChange={(e) => { setDisc(!disc); handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherDiscAuditvaVisual}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {disc ?
                    <Slide direction="left" in={disc} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherDiscAuditvaVisualQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherDiscAuditvaVisualQuien"
                            disabled
                            onChange={(e) => {handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherDiscAuditvaVisualQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
            {/*------------ Convulsiones --------------- */}
            <Grid item lg={5} sm={5} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center", width: "100%" }}>
                    <Grid lg={8} sm={8} xs={12}>
                        <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px", width: "30%" }}>Convulsiones</FormLabel>
                    </Grid>
                    <Grid lg={4} sm={4} xs={12}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="antecedentesHeredoFamiliares,antherConvulsiones"
                            disabled
                            onChange={(e) => { setConv(!conv) ; handleChangeClinico(e)}}
                            value={historialFecha.antecedentesHeredoFamiliares.antherConvulsiones}
                        >
                            <FormControlLabel disabled  value={0} control={<Radio />} label="No" />
                            <FormControlLabel disabled  value={1} control={<Radio />} label="Si" />
                        </RadioGroup>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item lg={7} sm={7} xs={12}>
                {conv ?
                    <Slide direction="left" in={conv} mountOnEnter unmountOnExit>
                        <TextField
                            fullWidth
                            id="antherConvulsionesQuien"
                            label="¿Quien?"
                            name="antecedentesHeredoFamiliares,antherConvulsionesQuien"
                            disabled
                            onChange={(e) => {handleChangeClinico(e) }}
                            value={historialFecha.antecedentesHeredoFamiliares.antherConvulsionesQuien}
                            variant="standard"
                            autoComplete="family-name"
                        />
                    </Slide>
                    : null}
            </Grid>
        </Grid>
    )
}

export default HeredoFamiliaresDF